import api from '@/services/utils/apiInstance.ts';

import { buildPeriodQuery } from "@/services/utils/request.ts";
import { ExportFormatKey } from "@/enums/fees_enum.ts";
import { triggerExportFileDownload } from "@/utils/feesUtils.ts";

import type {
  PlatformFeesRequest,
  PlatformFeesResponse
} from "@/types/services/fees/platformFees.type.ts";
import type { PaginatedResponse } from "@/types/services/utils/response.type.ts";
import type {
  MandateFeesRowResponse,
  MandateFeesRowResponseApi
} from "@/types/services/fees/mandateFees.type.ts";
import type { PaginatedPeriodQuery } from "@/types/services/utils/request.type.ts";

class FeesService {
  async getPlatformFees(): Promise<PlatformFeesResponse> {
    const response = await api.get('/fees/platform');
    return response.data;
  }

  async updatePlatformFees(platformFeesData: PlatformFeesRequest): Promise<PlatformFeesResponse> {
    const response = await api.put('/fees/platform', platformFeesData);
    return response.data;
  }

  async getMandateFeesPaginated(params: PaginatedPeriodQuery): Promise<PaginatedResponse<MandateFeesRowResponse>> {
    const query: string = buildPeriodQuery(params);
    const response = await api.get(`/fees/paginated?${query.toString()}`);
    return {
      total: response.data.total,
      page: response.data.page,
      limit: response.data.limit,
      maxPages: response.data.max_pages,
      data: response.data.data.map((row: MandateFeesRowResponseApi) => ({
        mandateName: row.mandate_name,
        investedAmount: row.invested_amount,
        percentage: row.percentage,
        feesAmount: row.fees_amount,
      }))
    }
  }

  async exportMyFees(period: string, exportFormat: ExportFormatKey): Promise<void> {
    const response = await api.post("/fees/export", {
      exportFormat: exportFormat,
      period: period,
    }, {
      responseType: "blob",
    });

    // Axios normally lowercases all headers
    const contentDisposition: string | undefined = response.headers["content-disposition"];

    triggerExportFileDownload(
      contentDisposition,
      period,
      response.data,
      exportFormat
    );
  }
}

export default new FeesService();